import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "message-reaction-picker__row"
}
const _hoisted_2 = ["onClick"]

import { ref, watch, nextTick, onBeforeUnmount } from "vue";
import { Icon } from "@iconify/vue";
import EmojiPicker from "./EmojiPicker.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MessageReactionPicker',
  props: {
    show: { type: Boolean },
    triggerEl: {}
  },
  emits: ["select", "close"],
  setup(__props: any, { emit: __emit }) {

const QUICK_REACTIONS = ["👍", "❤️", "😂", "😮", "😢", "🙏"];

const props = __props;

const emit = __emit;

const quickReactions = QUICK_REACTIONS;
const showFullPicker = ref(false);
const panelRef = ref<HTMLElement | null>(null);
const panelStyle = ref<Record<string, string>>({
  position: "fixed",
  zIndex: "11000",
  visibility: "hidden",
});

function selectEmoji(emoji: string) {
  emit("select", emoji);
}

function handleFullPickerSelect(payload: { emoji: string; name: string }) {
  emit("select", payload.emoji);
}

function updatePosition() {
  if (!props.triggerEl || !panelRef.value) return;

  const triggerRect = props.triggerEl.getBoundingClientRect();
  const panelWidth = panelRef.value.offsetWidth || 260;
  const panelHeight = panelRef.value.offsetHeight || 48;
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const gap = 8;

  const spaceBelow = vh - triggerRect.bottom;
  const spaceAbove = triggerRect.top;
  const showAbove = spaceAbove > spaceBelow && spaceAbove >= panelHeight + gap;

  let top = showAbove ? triggerRect.top - panelHeight - gap : triggerRect.bottom + gap;
  top = Math.max(8, Math.min(top, vh - panelHeight - 8));

  let left = triggerRect.left + triggerRect.width / 2 - panelWidth / 2;
  left = Math.max(8, Math.min(left, vw - panelWidth - 8));

  panelStyle.value = {
    position: "fixed",
    top: `${top}px`,
    left: `${left}px`,
    zIndex: "11000",
    visibility: "visible",
  };
}

function handleClickOutside(event: MouseEvent) {
  const target = event.target as Node;
  if (panelRef.value?.contains(target)) return;
  if (props.triggerEl?.contains(target)) return;
  emit("close");
}

watch(
  () => props.show,
  async (val) => {
    if (val) {
      showFullPicker.value = false;
      panelStyle.value = {
        position: "fixed",
        zIndex: "11000",
        visibility: "hidden",
        top: "-9999px",
        left: "-9999px",
      };
      await nextTick();
      requestAnimationFrame(() => {
        updatePosition();
      });
      window.addEventListener("scroll", updatePosition, true);
      window.addEventListener("resize", updatePosition);
      document.addEventListener("mousedown", handleClickOutside, true);
    } else {
      window.removeEventListener("scroll", updatePosition, true);
      window.removeEventListener("resize", updatePosition);
      document.removeEventListener("mousedown", handleClickOutside, true);
    }
  }
);

watch(showFullPicker, async () => {
  await nextTick();
  requestAnimationFrame(() => {
    updatePosition();
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", updatePosition, true);
  window.removeEventListener("resize", updatePosition);
  document.removeEventListener("mousedown", handleClickOutside, true);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "panelRef",
          ref: panelRef,
          class: "message-reaction-picker",
          style: _normalizeStyle(panelStyle.value)
        }, [
          (!showFullPicker.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(quickReactions), (emoji) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: emoji,
                    type: "button",
                    class: "message-reaction-picker__emoji-btn",
                    onClick: ($event: any) => (selectEmoji(emoji))
                  }, _toDisplayString(emoji), 9, _hoisted_2))
                }), 128)),
                _createElementVNode("button", {
                  type: "button",
                  class: "message-reaction-picker__expand-btn",
                  title: "More emojis",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showFullPicker.value = true))
                }, [
                  _createVNode(_unref(Icon), { icon: "mdi:plus" })
                ])
              ]))
            : (_openBlock(), _createBlock(EmojiPicker, {
                key: 1,
                onSelect: handleFullPickerSelect
              }))
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})